module Meevo.Plugins.EmployeeSupplyUsage {
    "use strict";

    export class HistorySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.BlockType> {
        public increments = [];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            public durationIncrements,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings);
            this.durationIncrements.getIncrements(480, false)
                .then((increments) => {
                    this.increments = increments;
                });
        }
    }

}

    /*
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import ISupplyUsageLineItem = Meevo.Model.ISupplyUsageLineItem;
    import Variant = Meevo.Model.Variant;
    import EmployeeListItem = Meevo.Model.EmployeeListItem;
    import ChangedDateEnum = Meevo.Components.Controls.ChangedDateEnum;

    interface IDateRange {
        from: Date;
        to: Date;
        presetList: Array<any>;
        predefinedPresetStatus: PresetStatus
    };

    /**
     * History Section of EmployeeSupplyUsage
     *//*
    export class HistorySection extends Meevo.Components.CommonClasses.CommonSectionBase {
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton> = [];
        public dateRange: IDateRange = {
            from: null,
            to: null,
            presetList: [
                { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
                { name: 'LABEL_TODAY', status: PresetStatus.Today },
                { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
                { name: 'LABEL_LAST_SEVEN_DAYS', status: PresetStatus.LastSevenDays },
                { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
                { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
                { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
                { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
                { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
                { name: 'LABEL_THIS_QUARTER ', status: PresetStatus.ThisQuarter },
                { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter }
            ],
            predefinedPresetStatus: PresetStatus.LastSevenDays
        };
        public history: Array<ISupplyUsageLineItem>;
        public selectedProduct: Variant;
        public selectedEmployee: EmployeeListItem;
        public employeeTypeAheadCriteria: Object = {
            showEmployeesOnly: true,
            showTerminated: false,
            includeInactive: true,
            includeActive: true
        };

        public disableCrud: boolean = true;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $scope: angular.IScope,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService,null,identityService,sectionSecurityKey);

            if (this.identityService.inCentralOfficeMode()) {
                // in order to follow standard typeAhead rules
                angular.extend(this.employeeTypeAheadCriteria, {
                    coSearchType: Meevo.Model.CoSearchType.CentralOffice,
                    coSearchResultFilter: Meevo.Model.CoSearchResultsFilter.LocationOverrides
                });
            }
        }

        /**
         * Callback for meevo-date-range-with-presets directive
         * @param {ChangedDateEnum} changedDate
         */
         /*
        public dateChanged(changedDate: ChangedDateEnum): void {
            if (!this.isDateValide()) return;

            // User Story 38804. Scenario: I filter results by a product - I am not restricted to 90 days
            if (this.isDateOutOfRange() && !this.selectedProduct) {
                if (changedDate === ChangedDateEnum.From) {
                    this.modalService.alert('LABEL_END_DATE_HAS_BEEN_ADJUSTED_TO_90_DAYS', Components.Modal.ModalTranslationModes.Translate).then(() => {
                        this.dateRange.to = moment(this.dateRange.from).add(90, 'days').toDate();
                    });
                } else if (changedDate === ChangedDateEnum.To || changedDate === ChangedDateEnum.Both) {
                    this.modalService.alert('LABEL_START_DATE_HAS_BEEN_ADJUSTED_TO_90_DAYS', Components.Modal.ModalTranslationModes.Translate).then(() => {
                        this.dateRange.from = moment(this.dateRange.to).subtract(90, 'days').toDate();
                    });
                }
            } else {
                this.filterData();
            }
        }

        /**
         * Do filtering
         *//*
        private filterData(): void {
            let data = {
                criteria: {
                    startDateTime: this.dateRange.from,
                    endDateTime: this.dateRange.to,
                    employee_User_TId: this.selectedEmployee ? this.selectedEmployee.id : undefined,
                    variant_TId: this.selectedProduct ? this.selectedProduct.id : undefined
                },
                itemsPerPage: 10000
            };

            this.busyService.start();
            this.dataService.customMethodData('/api/Inventory/SupplyUsage/List', 'POST', data)
                .then((response) => {
                    for (var i = 0; i < response.data.length; i++) {
                        response.data[i]['quantityDisplay'] = Number(response.data[i]['quantity']).toFixed(2);
                    }
                    this.history = response.data;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Show modal window with product and employee loockups inside
         */
         /*
        public showAdvancedFilter(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/employeeSupplyUsage/sectionViews/advancedFilter.modal.html',
                controller: 'meevo.plugins.employeeSupplyUsage.AdvancedFilterController',
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    selectedProduct: this.selectedProduct,
                    selectedEmployee: this.selectedEmployee,
                    employeeTypeAheadCriteria: this.employeeTypeAheadCriteria
                }
            }
            this.modalService.showCustom(options).then((data) => {
                this.selectedProduct = data.selectedProduct;
                this.selectedEmployee = data.selectedEmployee;

                if (this.selectedProduct) {
                    this.filterData();
                } else {
                    // in order to invoke date validation before filtering(show restriction modal window) if date was set up more then 90 days and product was selected
                    this.dateChanged(ChangedDateEnum.Both);
                }
            });
        }

        /**
         * Check if date is out of range
         * @returns {boolean}
         */
         /*
        private isDateOutOfRange(): boolean {
            let from = moment(this.dateRange.from),
                to = moment(this.dateRange.to);

            return to.diff(from, 'days') > 90;
        }

        /**
         * Check if end date goes after start date
         * @returns {boolean}
         */
         /*
        private isDateValide(): boolean {
            let from = moment(this.dateRange.from),
                to = moment(this.dateRange.to);

            return to.isAfter(from);
        }
    }

}*/